import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EditRoleAssignmentPage } from './edit-role-assignment.page';

const routes: Routes = [
  {
    path: '',
    component: EditRoleAssignmentPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditRoleAssignmentPageRoutingModule {}
